import isArrayNotEmpty from '@/tools/isarraynotempty';
import {
  pluralizeRuble,
  pluralizeLecture,
  pluralizeLesson,
} from '@/tools/pluralize';

const toStringArray = (array: Array<{ id: string; name: string }>) => {
  if (!isArrayNotEmpty(array)) return [];
  return array.map(({ name }) => name);
};

const toStringSidebar = (array: Array<{ id: string; name: string }>) => {
  if (!isArrayNotEmpty(array)) return '';
  return array.map(({ name }) => name).join(', ');
};

const parseModule = (data: any) => ({
  id: data!.id || '',
  professionId: data!.profession_id || '',
  sidebar: {
    events: toStringSidebar(data.events),
    cop_multi_name: data.cop_multi_name || '',
    competences: toStringSidebar(data.competences),
    studentCategories: isArrayNotEmpty(data.student_categories)
      ? data.student_categories.join(', ')
      : '',
    formEducationId: data!.form_education_id || '',
    isOvz: data!.is_ovz || false,
    freeCost: data!.free_cost || '',
    cost:
      data.cost && typeof data.cost === 'string'
        ? pluralizeRuble(parseFloat(data.cost))
        : '',
    profession: data.profession ? data.profession : {},
  },
  main: {
    announce: data!.announce || '',
    name: data!.name || '',
    practicalLessonsCount: pluralizeLesson(data.practical_lessons_count),
    lectureLessonsCount: pluralizeLecture(data.lecture_lessons_count),
    weeks: data!.duration_text || '',
    isPublishedConstructor: data!.is_published_constructor || false,
  },
  footer: {
    themes: toStringArray(data.themes),
    knows: toStringArray(data.knows),
    skills: toStringArray(data.skills),
  },
});

export default parseModule;



// WEBPACK FOOTER //
// ./src/services/api/event-modules/utils/parseModule.ts